import { FormControl, Grid, InputLabel, Select, TextField, Typography, Box, IconButton, InputAdornment } from '@mui/material';
import { Search as IconSearch } from "@mui/icons-material";
import api from "../services/api";
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setEntity, setData, setValidationMessage, activeValidations
    , setListObjetivos, setListTemas, setListEstados } from "../redux/participanteObjetivoSlice";
import { FormHelperText as HelperText } from '@mui/material';
import ParticipanteSearch from './ParticipanteSearch';

// Objetivos asignados a un participante. Cada fila es un objetivo, que puede
// venir del catalogo o escribirse solo para ese participante.
const ParticipanteObjetivo = (props) => {
    const isReadOnly = props.isReadOnly;
    const params = useParams();
    const entity = useSelector((state) => state.participanteObjetivo.entity);
    const defaultEntity = useSelector((state) => state.participanteObjetivo.defaultEntity);
    const listObjetivos = useSelector((state) => state.participanteObjetivo.listObjetivos);
    const listTemas = useSelector((state) => state.participanteObjetivo.listTemas);
    const listEstados = useSelector((state) => state.participanteObjetivo.listEstados);
    const validate = useSelector((state) => state.participanteObjetivo.validationActive);
    const dispatch = useDispatch();
    const [openParticipanteSearch, setOpenParticipanteSearch] = useState(false);

    var validation = {
        idParticipante: {
            error: entity.idParticipante == null || entity.idParticipante == 0,
            message: "Falta ingresar el participante",
        },
        idTemaEvaluacion: {
            error: entity.idTemaEvaluacion == null || entity.idTemaEvaluacion == 0,
            message: "Falta ingresar el tema",
        },
        nombre: {
            error: entity.nombre == null || entity.nombre.trim().length < 1,
            message: "Falta ingresar el nombre",
        },
        fechaInicio: {
            error: entity.fechaInicio == null,
            message: "Falta ingresar la fecha de inicio",
        },
        valorInicial: {
            error: entity.valorInicial == null || entity.valorInicial.trim().length < 1,
            message: "Falta ingresar el valor inicial",
        },
        criterioLogro: {
            error: entity.criterioLogro == null || entity.criterioLogro.trim().length < 1,
            message: "Falta ingresar el criterio de logro",
        },
        idEstado: {
            error: entity.idEstado == null || entity.idEstado == 0,
            message: "Falta ingresar el estado",
        },
    }

    const fetchEntity = useCallback(async () => {
        if (parseInt(params.id || "0") <= 0) {
            dispatch(setEntity(defaultEntity));
            return;
        }

        await api.get("/Evaluacion/GetsParticipanteObjetivoView")
            .then((response) => {
                const encontrado = (response.data?.data || []).find((row) => row.id == params.id);

                if (encontrado == null) {
                    dispatch(setEntity(defaultEntity));
                }
                else {
                    dispatch(setEntity(encontrado));
                }
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
    }, [])

    // Los objetivos del catalogo: al elegir uno se copian su nombre, su
    // descripcion y su tema al objetivo del participante.
    const fetchListObjetivos = useCallback(async () => {
        const response = await api.get("/Evaluacion/GetsObjetivoCatalogoView?idTemaEvaluacion=0")
            .catch((err) => {
                console.log("Err: ", err)
            });
        dispatch(setListObjetivos(response?.data?.data || []));
    }, [])

    // Los grupos (tema padre) no se listan: solo los temas que se evaluan.
    const fetchListTemas = useCallback(async () => {
        const response = await api.get("/Evaluacion/GetsTemaEvaluacionView")
            .catch((err) => {
                console.log("Err: ", err)
            });
        dispatch(setListTemas((response?.data?.data || []).filter((row) => row.idTemaPadre != null)));
    }, [])

    const fetchListEstados = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=1")
            .catch((err) => {
                console.log("Err: ", err)
            });
        dispatch(setListEstados(response?.data?.data || []));
    }, [])

    useEffect(() => {
        fetchEntity();
        fetchListObjetivos();
        fetchListTemas();
        fetchListEstados();
        dispatch(setValidationMessage(messagesValidation()));
    }, []);

    useEffect(() => {
        dispatch(setValidationMessage(messagesValidation()));
    }, [entity])

    var setDataEntity = e => {
        dispatch(setData(e.target));
    }
    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        });

        return messages;
    }

    // Al elegir un objetivo del catalogo, se copian su nombre, su descripcion
    // y su tema. Se puede cambiar despues: cada participante se mide distinto.
    const setObjetivoCatalogo = (event) => {
        const id = parseInt(event.target.value || "0");
        const encontrado = (listObjetivos || []).find((row) => row.id == id);

        dispatch(setData({ name: "idObjetivoCatalogo", value: id > 0 ? id : null }))

        if (encontrado != null) {
            dispatch(setData({ name: "idTemaEvaluacion", value: encontrado.idTemaEvaluacion }))
            dispatch(setData({ name: "nombre", value: encontrado.nombre || "" }))
            dispatch(setData({ name: "descripcion", value: encontrado.descripcion || "" }))
        }
    }

    return (
        <Grid container>
            <Grid item>
                <Box sx={{ fontWeight: 'bold' }} padding={0}>
                    <Typography variant="h7">
                        Datos Basicos
                    </Typography>
                </Box>
            </Grid>
            <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                {/* El participante se busca con la lupa, igual que en la
                    evaluacion: la lista completa es larga. */}
                <Grid item xs={6} sm={3}>
                    <FormControl required fullWidth error={validate.idParticipante && validation.idParticipante.error}>
                        <TextField
                            label="Participante"
                            fullWidth
                            value={entity.participante == null ? "" : entity.participante}
                            InputProps={{
                                readOnly: true,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="buscar participante"
                                            size="small"
                                            disabled={isReadOnly}
                                            onClick={() => setOpenParticipanteSearch(true)}>
                                            <IconSearch fontSize="small" />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            InputLabelProps={{ shrink: true }}
                            disabled={isReadOnly}
                            size="small"
                        />
                        <HelperText>
                            {validate.idParticipante && validation.idParticipante.error ? validation.idParticipante.message : ""}
                        </HelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="input-objetivo">Objetivo del catalogo</InputLabel>
                        <Select
                            native
                            label="Objetivo del catalogo"
                            value={entity.idObjetivoCatalogo == null ? 0 : entity.idObjetivoCatalogo}
                            onChange={setObjetivoCatalogo}
                            inputProps={{
                                name: 'idObjetivoCatalogo',
                                id: 'input-objetivo',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Ninguno)"}</option>
                            {listObjetivos.map((row) => (
                                <option key={row.id} value={row.id}>{row.tema + " - " + row.nombre}</option>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl required fullWidth error={validate.idTemaEvaluacion && validation.idTemaEvaluacion.error}>
                        <InputLabel htmlFor="input-tema">Tema</InputLabel>
                        <Select
                            native
                            label="Tema"
                            value={entity.idTemaEvaluacion}
                            onChange={setDataEntity}
                            inputProps={{
                                name: 'idTemaEvaluacion',
                                id: 'input-tema',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listTemas.map((row) => (
                                <option key={row.id} value={row.id}>{row.temaPadre + " - " + row.nombre}</option>
                            ))}
                        </Select>
                        <HelperText>
                            {validate.idTemaEvaluacion && validation.idTemaEvaluacion.error ? validation.idTemaEvaluacion.message : ""}
                        </HelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl required fullWidth error={validate.nombre && validation.nombre.error}>
                        <TextField
                            required
                            name="nombre"
                            label="Nombre"
                            fullWidth
                            value={entity.nombre}
                            onChange={setDataEntity}
                            error={validate.nombre && validation.nombre.error}
                            helperText={validate.nombre && validation.nombre.error ? validation.nombre.message : ""}
                            disabled={isReadOnly}
                            size="small"
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <TextField
                            name="descripcion"
                            label="Descripcion"
                            fullWidth
                            value={entity.descripcion}
                            onChange={setDataEntity}
                            disabled={isReadOnly}
                            size="small"
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl required fullWidth error={validate.fechaInicio && validation.fechaInicio.error}>
                        <TextField
                            required
                            name="fechaInicio"
                            label="Fecha de inicio"
                            type="date"
                            fullWidth
                            value={entity.fechaInicio == null ? "" : String(entity.fechaInicio).substring(0, 10)}
                            onChange={setDataEntity}
                            error={validate.fechaInicio && validation.fechaInicio.error}
                            helperText={validate.fechaInicio && validation.fechaInicio.error ? validation.fechaInicio.message : ""}
                            InputLabelProps={{ shrink: true }}
                            disabled={isReadOnly}
                            size="small"
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl required fullWidth error={validate.valorInicial && validation.valorInicial.error}>
                        <TextField
                            required
                            name="valorInicial"
                            label="Valor inicial"
                            fullWidth
                            value={entity.valorInicial}
                            onChange={setDataEntity}
                            error={validate.valorInicial && validation.valorInicial.error}
                            helperText={validate.valorInicial && validation.valorInicial.error ? validation.valorInicial.message : ""}
                            disabled={isReadOnly}
                            size="small"
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl required fullWidth error={validate.criterioLogro && validation.criterioLogro.error}>
                        <TextField
                            required
                            name="criterioLogro"
                            label="Criterio de logro"
                            fullWidth
                            value={entity.criterioLogro}
                            onChange={setDataEntity}
                            error={validate.criterioLogro && validation.criterioLogro.error}
                            helperText={validate.criterioLogro && validation.criterioLogro.error ? validation.criterioLogro.message : ""}
                            disabled={isReadOnly}
                            size="small"
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl required fullWidth error={validate.idEstado && validation.idEstado.error}>
                        <InputLabel htmlFor="input-estado">Estado</InputLabel>
                        <Select
                            native
                            label="Estado"
                            value={entity.idEstado}
                            onChange={setDataEntity}
                            inputProps={{
                                name: 'idEstado',
                                id: 'input-estado',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listEstados.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        <HelperText>
                            {validate.idEstado && validation.idEstado.error ? validation.idEstado.message : ""}
                        </HelperText>
                    </FormControl>
                </Grid>
            </Grid>
            <ParticipanteSearch
                open={openParticipanteSearch}
                openClose={() => setOpenParticipanteSearch(false)}
                setSelection={(row) => {
                    dispatch(setData({ name: "idParticipante", value: row.id }))
                    dispatch(setData({ name: "participante", value: row.participante }))
                }}
            />
        </Grid>
    );
}

export default ParticipanteObjetivo;
